export default "__VITE_ASSET__DIhvbVlI__"